import { prepareHeadersForGlobalFilters } from "../PagesContent/Overview/CommonFunctions";
import { GetData } from "./Functions/SettingData";
import qs from "qs";
import { getBmsFaultErrorCodesHeader } from "./Functions/BmsFaultHeader";

export const getFleets = async () => {
  var config = {
    method: "get",
    url: `/api/v1/fleets`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  let data = GetData(config);
  return data;
};

export const getOnboardingLocations = async (fleetIds) => {
  var config = {
    method: "get",
    url: `/api/v1/onboarding-location-meta`,
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      fleetIds,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = GetData(config);
  return data;
};

export const getSummaryStats = async (globalFilters) => {
  const headers = prepareHeadersForGlobalFilters(globalFilters, 'overview');

  var config = {
    method: "get",
    url: `/api/v1/overview`,
    headers,
  };

  let data = GetData(config);
  return data;
};

export const getDiagnosticsStats = async (globalFilters, includeResolvedStats = false, module = null) => {
  const headers = { ...prepareHeadersForGlobalFilters(globalFilters, module), ...getBmsFaultErrorCodesHeader() };

  var config = {
    method: "get",
    url: `/api/diagnostics/v2/stats`,
    headers,
    ...(includeResolvedStats && { params: { includeResolvedStats: true } }),
  };

  let data = GetData(config);
  return data;
};
